import React from 'react'
import PeInstallationDialog from './PeInstallationDialog'
import { useSelector } from 'react-redux'
import State from '../../states/State'

type PeCrudDialogProps = {}

const PeCrudDialog: React.FC<PeCrudDialogProps> = () => {
  const state = useSelector((state: State) => ({
    shell: state.shell,
    dialog: state.dialog,
  }));

  const renderDialog = () => {
    if (!state.dialog?.crudDialog || state.dialog?.crudDialog === '') {
      return <></>
    }
    switch (state.dialog.crudDialog) {
      case 'installation':
        return <PeInstallationDialog />
      default: return <></>
    }
  }

  return <>{renderDialog()}</>
}

export default PeCrudDialog;